export const HERO_VERSIONS = {
  crypto: 1,
  watch: 2
}
